module.exports = __webpack_public_path__ + "static/media/google-maps.28f7c36a.png";